import { getInfo, setInfo } from '@/utils/storage'
export default {
  namespaced: true,
  state () {
    return {
      // 个人权证相关
      user: getInfo()
    }
  },
  getters: {

  },
  mutations: {
    setUserInfo (state, obj) {
      state.user = obj
      setInfo(obj)
    }
  },
  actions: {
    logout (context) {
      // 重置个人信息
      context.commit('setUserInfo', {})
      context.commit('mygoods/setMyGoodsList', [], { root: true })
      context.commit('mygoods/setMyCollectionList', [], { root: true })
      context.commit('mygossips/setMyGossipList', [], { root: true })
      context.commit('mytasks/setMyTaskList', [], { root: true })
      context.commit('myrents/setMyRentList', [], { root: true })
      context.commit('mygamedatas/setMyGameDataList', [], { root: true })
    }
  }
}
